import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/UsersTable.styles'

const UserRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={[classes.tableRow, classes.tableRowSkeleton].join(' ')}>
        <div className={classes.nameCell}>
          <div className={classes.userLogo} />
          <div className={classes.userInfoContainerSkeleton}>
            <Typography variant="h4" className={classes.userInfoNameSkeleton}>
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
      </div>
    </>
  )
}

export default UserRowSkeleton
